import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeatInformationComponent } from './seat-information.component';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { AirportNamePipeModule } from '../../pipes/airport-name/airport-name.module';

@NgModule({
  declarations: [SeatInformationComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule, AirportNamePipeModule],
  exports: [SeatInformationComponent],
})
export class SeatInformationModule {}
